import { ButtonColor } from "sb-resp-ui";
export const getLogOutButtonProps = (title, onClick) => {
    return {
        title,
        color: ButtonColor.Link,
        onClick,
        dataUat: "button-reality-check-log-out"
    };
};
//# sourceMappingURL=getLogOutButtonProps.js.map